import { get } from "@/api/axios";

// /web/house/label/list get
export const list = params => get('/web/balance/record/list', params);



